"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSession = void 0;
/**
 * Returns the session object {@link ISession} which includes
 * the healthCareUserId, healthcareSessionId and other tracking
 * information like campaign parameters.
 *
 * @public
 *
 * @typeParam T - The type of the repository that should implement
 * the {@link ICreateSessionRepository} interface
 *
 * @param provider - The provider instance to handle session.
 *
 * @returns The session object. See {@link ISession}
 *
 * @example
 * ```ts
 * import {createSessionRepository} from '@hc-frontend/business';
 *
 * const session = createSession(createSessionRepository);
 * ```
 */
async function createSession(provider) {
    const session = await provider.fetchNewSession(provider.getPayload());
    if (session) {
        const success = provider.saveSession(session);
        if (!success) {
            provider.logError(new Error('Error on save session ids'));
        }
    }
    else {
        provider.logError(new Error('Error on create session'));
    }
    return session;
}
exports.createSession = createSession;
//# sourceMappingURL=create-session.js.map